export default "__VITE_ASSET__CqAqKdYr__"